export default __webpack_public_path__ + "static/FreeTrial_02-c74fb69b14ed06b5bf99934a10a681ac.svg";